import { UsuariosService } from '@app/_services';

export function appInitializer(usuariosService: UsuariosService) {
    return () => new Promise(resolve => {
        // attempt to refresh token on app start up to auto authenticate
        usuariosService.refreshToken()
            .subscribe()
            .add(resolve);
    });
}